// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page__3gI1R","card":"Login_card__jgS_I","title":"Login_title__1esOl","subtitle":"Login_subtitle__3gROw","error":"Login_error__eFDky","submit":"Login_submit__Pk0oC"};